var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentsection(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "40px",
    viewBox: "0 0 43 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B174FB00-DA3F-4C22-863F-79F687AA5A9A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Products---detail--add-section",
    transform: "translate(-748.000000, -328.000000)",
    stroke: "#E10210",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(689.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    transform: "translate(60.833333, 23.916667)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 10.3333333,
    x2: 15,
    y2: 10.3333333,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 18.0833333,
    x2: 15,
    y2: 18.0833333,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 25.8333333,
    x2: 15,
    y2: 25.8333333,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 23.25,
    x2: 5,
    y2: 23.25,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 23.25,
    x2: 5,
    y2: 23.25,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.5,
    y1: 12.9166667,
    x2: 5,
    y2: 12.9166667,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12.9166667,
    x2: 5,
    y2: 12.9166667,
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,12.9166671 L5,10.3333339 C5,4.62639118 9.47715275,0 15,0 L30,0 C35.5228469,0 40,4.62639118 40,10.3333339 L40,25.8333339 C40,31.5402751 35.5228469,36.1666667 30,36.1666667 L15,36.1666667 C9.47715275,36.1666667 5,31.5402751 5,25.8333339 L5,23.2499995",
    id: "Vector-21-path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 12.9166667,
    x2: 5,
    y2: 23.25,
    id: "Vector-21-path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsection);
export default __webpack_public_path__ + "static/media/Document section.90f36742100c20624745c7359292ed56.svg";
export { ForwardRef as ReactComponent };